import type { FunctionType } from 'api/types';

export const getFuncArgs = (
  functionType?: FunctionType,
  args: string[] = [],
  isAdvanced: boolean = true,
) => {
  if (!isAdvanced) {
    return args;
  }

  const funcArgs = ['conv: Conversation'];
  if (functionType === 'flow_function') {
    funcArgs.push('flow: Flow');
  }
  return funcArgs.concat(args).join(', ');
};

export const sanitiseFunctionName = (name: string) =>
  name
    .trim()
    .replace(/[^a-zA-Z0-9_\s\-]/g, '')
    .replace(/^[\s\-]+|[\s\-]+$/g, '')
    .replace(/[\s\-]+/g, '_')
    .toLowerCase();

export const isStartOrEndFunction = (name: string | undefined) =>
  name === 'start_function' || name === 'end_function';
